import { render } from "./StoreHeaderCat.vue?vue&type=template&id=7af9b87a&scoped=true"
import script from "./StoreHeaderCat.vue?vue&type=script&lang=js"
export * from "./StoreHeaderCat.vue?vue&type=script&lang=js"

import "./StoreHeaderCat.vue?vue&type=style&index=0&id=7af9b87a&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af9b87a"]])

export default __exports__